// extracted by mini-css-extract-plugin
export default {"item":"IconLink-module--item--981d8","icon":"IconLink-module--icon--c10da"};